<template>
  <div
    class="cursor-pointer p-3 rounded-xl flex hover:bg-gray-50 flex-col border lg:border-4 items-center justify-start text-center gap-4 leading-tight relative shadow-md"
    :class="{
      'bg-[#eaffe9] hover:bg-[#eaffe9] text-white border-theme-primary': isSelected && is_bod,
      'bg-[#e5f0ff] text-white border-light-blue': isSelected && is_elecom,
      'bg-[#e5f0ff] text-white border-dark-blue': isSelected && is_audit,
      'bg-white': !isSelected
    }"
    @click="$emit('select', candidate)"
  >
    <div class="relative w-full">
      <img 
        :src="candidate.image" 
        class="w-full rounded-xl object-cover"
        @error="setPlaceholder"
      />
      
      <div 
        v-if="isSelected" 
        class="absolute p-1 lg:p-2 rounded-full flex items-center justify-center shadow-lg top-1 right-1"
        :class="{
          'bg-theme-primary': is_bod,
          'bg-light-blue': is_elecom,
          'bg-dark-blue': is_audit
        }"
      >
        <img src="@/assets/images/papsi_check.svg" class="w-3 h-3 lg:w-6 lg:h-6" />
      </div>
    </div>

    <div>
      <p class="text-base lg:text-xl text-grey-darkest font-semibold uppercase" :class="{
          'text-theme-primary': is_bod && isSelected,
          'text-light-blue': is_elecom && isSelected,
          'text-dark-blue': is_audit && isSelected,
          'text-grey': !isSelected
        }">{{ candidate.name }}</p>
      <!-- <p v-if="$route.name === 'audit-supervisory-committee'" -->
       <p v-if="!is_audit"
        class="text-sm lg:text-lg font-medium"
        :class="{
          'text-theme-primary': is_bod && isSelected,
          'text-light-blue': is_elecom && isSelected,
          'text-dark-blue': is_audit && isSelected,
          'text-grey': !isSelected
        }"
      >
        {{ candidate.type }}
      </p>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin';

export default {
  name: 'v-radiobox',
  mixins: [mixin],
  props: {
    candidate: Object,
    isSelected: Boolean,
    is_bod: Boolean,
    is_elecom: Boolean,
    is_audit: Boolean,
  },
  methods: {
    setPlaceholder(event) {
      event.target.src = 'https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg';
    }
  }
};
</script>

<style scoped>
</style>
